import { addMemedLog } from '@/components/healthPlan/utils/addLog'
import { LogLevel } from '@/wrappers/logger'

import {
  addMemedScript,
  destroyMemed,
  getMemedToken,
  getPersonData as getPersonDataAPI
} from './config'

const initMemed = async store => {
  store.commit('initMemedSetup')
  try {
    const res = await getMemedToken()
    addMemedLog(LogLevel.INFO, 'Adding memed script')
    addMemedScript(res.token, store)
    store.commit('setMemedToken', res.token)
  } catch (error) {
    addMemedLog(LogLevel.ERROR, 'Error getting memed token', { error })
    store.commit('initMemedResult', { error })
    destroyMemed()
  }
}

const getPersonData = async (store, personId) => {
  try {
    const personData = await getPersonDataAPI(personId)
    return personData
  } catch (error) {
    store.commit('initMemedResult', { error })
    addMemedLog(LogLevel.ERROR, 'Error getting patient information', { error })
    return null
  }
}

export default {
  initMemed,
  getPersonData
}
